import React from "react";
import "./App.scss";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

import Home from "./LandingPage/src/pages/Home/index";
import { NotFound } from "./LandingPage/src/pages/_404";
import SignIn from "./Other-Page-Components/Sign-In-Pages/Sign-In";
import ForgotPassword from "./Other-Page-Components/Sign-In-Pages/Forgot-Password";
import OtpVerify from "./Other-Page-Components/Sign-In-Pages/Otp-Verify";
import CaretakerDash from "./pages/caretakerDash";
import TenantDash from "./pages/tenantDash";

//admin page
import AdminDash from "./pages/adminDash";

function App() {
  return (
    <Router>
      {/* Keep this wrapper mounted at all times so external DOM manipulators (e.g. GSAP ScrollSmoother)
          don't move nodes out of React's current container and cause removeChild errors on navigation */}
      <div id="smooth-content">
        <Routes>
          {/* Home as a normal top-level route */}
          <Route path="/" element={<Home />} />

          {/* Standalone Authentication Routes with Dedicated Split-Panel Layout */}
          <Route path="signin" element={<SignIn />} />
          <Route path="signup" element={<SignIn showContact />} />
          <Route path="verify" element={<OtpVerify />} />
          <Route path="forgot-password" element={<ForgotPassword />} />

          <Route path="*" element={<NotFound />} />

          <Route path="/auth" element={<Outlet />}>
            <Route path="caretaker" element={<CaretakerDash />}>
              {/* caretaker child routes can go here */}
            </Route>

            <Route
              path="tenant"
              element={
                <PrivateRoute
                  element={TenantDash}
                  requiredUserType="tenant"
                />
              }
            >
              {/* TenantDash renders the revamped views through dashboard context.
                  Keep these URLs without mounting the obsolete child pages. */}
              <Route path="invoices" element={<></>} />
              <Route path="payments" element={<></>} />
              <Route path="messages" element={<></>} />
            </Route>

            <Route
              path="landlord/:category/:propertyId/houses"
              element={
                <PrivateRoute
                  element={AdminDash}
                  requiredUserType="landlord"
                />
              }
            />

            <Route
              path="landlord/:category?"
              element={
                <PrivateRoute
                  element={AdminDash}
                  requiredUserType="landlord"
                />
              }
            >
              {/* landlord child routes can go here */}
            </Route>

            {/* KEEP THE REST OF YOUR /auth CHILD ROUTES HERE as needed */}
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
